














































































import FooterButton from "@/components/FooterButton.vue";
import { Component, Mixins } from "vue-property-decorator";
import {
  AppData,
  INCOME_RANGE,
} from "@/models/app-data";
import CommonMixin, { County } from "@/mixins/common-mixins";
import { ContentService } from "@/service/content.service";
import { WorkflowService } from "@/service/workflow.service";
import { EligibilityService } from "@/service/eligibility.service";
import { AlternateHSQualifierList3Content } from "@/models/content/alternate-hs-qualifier-list-3";
import { QualifierRule, matchQualifiers } from "@/models/rules";

@Component({
  components: {
    FooterButton
  }
})
export default class AlternateHSQualifierList3 extends Mixins(CommonMixin) {
[x: string]: any;
  PercentDone = 80;
  workflowService = new WorkflowService();
  eligibilityService = new EligibilityService();
  content: AlternateHSQualifierList3Content = {} as AlternateHSQualifierList3Content;
  migrantFarmWorkChecked = false;
  noneChecked = false;
  appData = {} as AppData;
  textDirection = 'ltr'
  checkTextAlign = 'has-text-left'
  includedZipCodes: Array<string>  = []

  async mounted(): Promise<void> {
    try {
      const contentService = new ContentService(this.$route);
      this.content = await contentService.getAlternateHSQualifierList3Content();
      this.textDirection = contentService.TextDirection();
      if ( this.textDirection == 'rtl'){
        this.checkTextAlign = 'has-text-right'
      }
      // Import the workflow if one is provided
      await this.loadData();
      if (this.appData != null) {
        this.migrantFarmWorkChecked = this.appData.migrantFarmWork;
        this.noneChecked = this.appData.hsQualifierList3None;
        this.putWorkflowStep( this.appData.workflowId, "AlternateHSQualifierList3") 
      }
    } catch (error) {
        this.showError(error as any);
    }
  }

  async loadData(): Promise<void> {
    if (this.$route?.query?.workflowid != null) {
      const workflowId = this.$route.query.workflowid + "";
      const appData = await this.workflowToAppData(workflowId);
      this.saveAppData(appData);
      this.appData = appData;

      //If we don't have the 250 plus income, redirect
      if (appData.fpl !== INCOME_RANGE.FPL_LVL_3_PLUS) {
        //If we don't have the income, redirect to initial requirements
        if (appData.eligibleIncome == null) {
          this.$router.replace({ path: "InitialRequirements" });
        } else {
          this.$router.replace({ path: "IncomeRange" });
        }
      }
    } else {
      this.appData = this.getAppData();
    }
  }

  optionChanged(e: { target: HTMLInputElement }): void {
    if (this.noneChecked === true) {
      this.noneChecked = false;
    }
  }

  noneChanged(e: { target: HTMLInputElement }): void {
    if (this.noneChecked == true) {
      this.migrantFarmWorkChecked = false;
    }
  }

  public oneOrMoreApplies(): boolean {
    return this.migrantFarmWorkChecked === true;
  }

  public handleNextPageEvent(): void {
    if (this.appData == null) {
      this.appData = {} as AppData;
    }
    this.appData.migrantFarmWork = this.migrantFarmWorkChecked;
    this.appData.hsQualifierList3None = this.noneChecked;

    const oneOrMoreApplies = this.oneOrMoreApplies(); 

    if (oneOrMoreApplies === true) {
      this.clearGSRPQualifiers(this.appData);
      this.clearGSRPQualifiersList2(this.appData);
    }

    this.saveAppData(this.appData);

    if (this.allChildrenUnder4(this.appData)) {
      this.handleAllUnderFour();
    } else if (this.allChildren4AndOver(this.appData)) {
      this.handleAllFourAndOver(oneOrMoreApplies);
    } else {
      this.handleBothUnderAndOverFour(oneOrMoreApplies);
    }
  }

  handleAllUnderFour(): void {
        const allUnder4Rules: QualifierRule[] = [
        { index: [true, County.Wayne, undefined], path: 'MatchHeadstartReferral' }
            ,{ index: [true, County.Oakland, undefined], path: 'MatchHeadstartReferral' }
            ,{ index: [true, County.Washtenaw, undefined], path: 'MatchHeadstartReferral' }
            ,{ index: [true, County.Macomb, undefined], path: 'MatchHeadstartReferral' }
            ,{ index: [false, undefined, INCOME_RANGE.FPL_LVL_1_TO_LVL_2], path: 'MatchNoneCDC' }
            ,{ index: [false, undefined, INCOME_RANGE.FPL_LVL_2_TO_LVL_3], path: 'MatchNone' }
            ,{ index: [false, undefined, INCOME_RANGE.FPL_LVL_3_PLUS], path: 'MatchNone' }
        ]

        const rule = matchQualifiers(allUnder4Rules, this.oneOrMoreApplies(), this.appData.county, this.appData.fpl)
        if (rule == null) {
            this.$router.push({ path: 'MatchNone' });
            return;
        }
        this.$router.push({ path: rule.path });
    }

  handleAllFourAndOver(oneOrMoreApplies: boolean): void {
    const rules: QualifierRule[] = [
     { index: [true, undefined, undefined], path: 'MatchHSGSRPLikelyReferral' }
    ,{ index: [false,undefined, undefined], path: 'AlternateGSRPQualifier' }
    ]

    const rule = matchQualifiers(rules, oneOrMoreApplies, this.appData.county, this.appData.fpl)
    if (rule == null) {
        this.$router.push({ path: 'MatchNone' });
        return;
    }
    this.$router.push({ path: rule.path });
  }

  handleBothUnderAndOverFour(oneOrMoreApplies: boolean): void {
    const rules: QualifierRule[] = [
     { index: [true, undefined, undefined], path: 'PreviouslyAppliedHS' }
    ,{ index: [false,undefined, undefined], path: 'AlternateGSRPQualifier' }
    ]

    const rule = matchQualifiers(rules, oneOrMoreApplies, this.appData.county, this.appData.fpl)
    if (rule == null) {
        this.$router.push({ path: 'MatchNone' });
        return;
    }
    this.$router.push({ path: rule.path });
  }

  disableNext(): boolean {
    return !(
      this.migrantFarmWorkChecked ||
      this.noneChecked
    );
  }
}
